export default __webpack_public_path__ + "static/media/Red0004.e38b0bb3.png";